<template>
  <div class="call-section">
    <div class="call-section-tabBar">
      <div
        :class="['call-section-tabBar-item', { active: tabKey === '1' }]"
        @click="onTabChange('1')"
        v-if="workbenchConfig && workbenchConfig.tabs.includes('today_calls')"
      >{{ $t('callPopScreen.todayCall') }}</div>
      <div
        :class="['call-section-tabBar-item', { active: tabKey === '2' }]"
        @click="onTabChange('2')"
        v-if="workbenchConfig && workbenchConfig.tabs.includes('missed_calls')"
        >{{ $t('callPopScreen.missCall') }}</div>
      <div
        :class="['call-section-tabBar-item', { active: tabKey === '3' }]"
        @click="onTabChange('3')"
        v-if="workbenchConfig && workbenchConfig.tabs.includes('call_plans')"
        >{{ $t('callPopScreen.contactPlan') }}</div>
      <div
        :class="['call-section-tabBar-item', { active: tabKey === '4' }]"
        @click="onTabChange('4')"
        v-if="workbenchConfig && workbenchConfig.tabs.includes('history_calls')"
        >{{ $t('callPopScreen.callHistory') }}</div>
    </div>
    <div v-show="tabKey === '1'" class="call-section-content">
      <TodayCall @tabchange="onTabChange" />
    </div>
    <div v-show="tabKey === '2'" class="call-section-content">
      <MissCall ref="missCallRef" />
    </div>
    <div v-show="tabKey === '3'" class="call-section-content">
      <LaterContact ref="laterContactRef" />
    </div>
    <div v-show="tabKey === '4'" class="call-section-content">
      <CallHistory />
    </div>
  </div>
</template>

<script>
import TodayCall from '../todayCall'
import MissCall from '../missCall'
import LaterContact from '../laterContact'
import CallHistory from '../callHistory'
export default {
  props: {
    workbenchConfig: {
      type: Object
    }
  },
  data() {
    return {
      tabKey: '1'
    }
  },
  components: {
    TodayCall,
    MissCall,
    LaterContact,
    CallHistory
  },
  computed: {
  },
  methods: {
    onTabChange(key) {
      this.tabKey = key
      if(key === '2') {
        this.$refs.missCallRef && this.$refs.missCallRef.refresh()
      } else if(key === '3') {
        this.$refs.laterContactRef && this.$refs.laterContactRef.refresh()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.call-section {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .call-section-tabBar {
    flex-shrink: 0;
    display: flex;
    height: 48px;
    border-bottom: 1px solid #EBEDF0;
    &-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: #646566;
      font-size: 14px;
      cursor: pointer;
      user-select: none;
      text-align: center;
      padding: 0 6px;
      &.active {
        font-weight: 600;
        color: #323233;
        font-size: 14px;
      }
    }
  }
  .call-section-content {
    flex: 1;
    height: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/callSection/index.vue